import React, { useState, useRef, useEffect } from "react";
import { FaPlayCircle } from "react-icons/fa"; // Import play icon

const PortfolioCard = ({ id, title, description, video, poster }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoRef = useRef(null); // Reference for the video element

  // Split the title into two parts: name and subtitle
  const [name, subtitle] = title.split(": ");

  // Function to open the modal and trigger full screen
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal and exit full screen
  const closeModal = (e) => {
    e.stopPropagation()
    setIsModalOpen(false);
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  // Trigger full screen when the modal opens
  useEffect(() => {
    if (isModalOpen && videoRef.current) {
      videoRef.current.requestFullscreen().catch((err) => {
        console.error("Failed to enter full screen:", err);
      });
    }
  }, [isModalOpen]);

  return (
    <div
      className="h-full relative p-6 rounded-2xl shadow-lg text-white bg-gradient-to-t from-indigo-500 to-purple-600 overflow-hidden cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={openModal} // Opens modal on card click
    >
      {/* Poster or Video Preview */}
      <div className={`relative w-full ${id===0?"h-72":"h-48"} rounded-lg mb-4`}>
        {isHovered ? (
          <video
            src={video}
            poster={poster}
            autoPlay
            muted
            loop
            className="w-full h-full object-cover rounded-lg"
            onLoadedMetadata={(e) => {
                if(id==9) e.target.currentTime = 5;
                else if(id==1) e.target.currentTime = 4.5;
            }}
          />
        ) : (
          <img
            src={poster}
            alt={title}
            className="w-full h-full object-cover rounded-lg"
          />
        )}

        {/* Play Icon */}
        <div className="absolute inset-0 flex justify-center items-center">
          <FaPlayCircle className="text-white text-5xl opacity-80 hover:opacity-100 transition-opacity" />
        </div>
      </div>

      {/* Title */}
      <h3 className="text-xl md:text-2xl font-extrabold mb-4 leading-tight">
        <span className="font-title">{name}</span>:{" "}
        <span className="font-body font-normal">{subtitle}</span>
      </h3>

      {/* Description */}
      <p className="text-lg font-body">{description}</p>

      {/* Modal for Video */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
          onClick={closeModal} // Close modal when background is clicked
        >
          <div
            className="relative w-[90%] max-w-3xl"
            onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside the video container
          >
            <video
              ref={videoRef} // Attach ref to the video element
              src={video}
              controls
              autoPlay
              className="w-full rounded-lg shadow-lg"
            />
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={closeModal}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioCard;
